import axios from "axios";
import { retryApiCall } from "../utils/retryApi.util";
import store from "../store";
import AuthService from "../services/AuthService";
import createAxiosInstance from "../interceptor/axiosInterceptor";
import appConfig from '@/config/appConfig';
const instance = createAxiosInstance(appConfig.VUE_APP_ASSESSMENT_API_URL);

export default {
  getAssessmentDetails: async function (
    campaignId,
    assessmentId,
    languages,
    assessmentResultId,
  ) {
    if (!store.getters.token) {
      alert('TOKEN NOT FOUND');
    } else {
      try {
        return await retryApiCall(
          () =>
            instance.get(`start-assessment-test?campaignId=${campaignId}&assessmentId=${assessmentId}&languages=${languages}&assessmentResultId=${assessmentResultId}&session=${localStorage.getItem('session') ?? null }`),
          4, // Max tries 4
          1200
        )
      } catch (error) {
        return error.response;
      }
    }
  },
  pollBreakTaken: async function (payload) {
    try{
      return await instance.put('poll-breakTaken', payload)
    }
    catch(error){
      console.log(error)
    }
    
  },
  saveAssessmentProgress: async function (
    questions,
    assessmentResultId,
    timeTaken,
    sectionTimeTaken,
    currentSectionIndex,
    selectedQuestion,
    isMestaAssessment,
    userId,
    campaignId,
    testType,
    unavailableSubjects,
    abortController,
    breakSummary,
  ) {
    if (!store.getters.token) {
      alert('TOKEN NOT FOUND');
    } 
    else {
      try {
        const data = {
          questions: questions.map((e, i) => {
            e.selectedQuestion = i === selectedQuestion;
            //delete e.questionAssetUrl;
            // delete e.questionOptions;
            delete e.questionStatement;
            delete e.previousStatus;
            delete e.status;
            return e;
          }),
          timeTaken,
          sectionTimeTaken,
          currentSectionIndex,
          session: localStorage.getItem('session') ?? null,
          breakSummary
        };
        const signal = abortController?.signal;
  
        // Add assessmentResultId for MESTA assessments
        if (isMestaAssessment) {
          data.assessmentResultId = assessmentResultId;
        }
        else{
          data.userId = userId;
          data.campaignId = campaignId;
          data.testType =  testType;
          data.unavailableSubjects = unavailableSubjects
        }
      
        // Determine API endpoint based on isMestaAssessment
        const endpoint = isMestaAssessment
          ? "save-assessment-progress"
          : "saveDynamicQuestionProgress";
        
        // Make the API call
        return await instance.post(endpoint, data, { signal });
      } catch (error) {
        console.error("AutoSave error:", error.message || error);
        return error.response;
      }
    }
  },
  submitStaticQuestion: async function ({
    campaignId,
    assessmentType,
    userId,
    questions,
    testType,
    assessmentResultId,
    timeTaken,
    isQuit: submittionType,
    breakSummary = false, 
  }) {
    if (!store.getters.token) {
      alert('TOKEN NOT FOUND');
    } else {
      try {
          const data = {
          questions: questions.map(e => {
            delete e.questionAssetUrl;
            delete e.questionOptions;
            delete e.questionStatement;
            delete e.subject;
            delete e.previousStatus;
            delete e.status;
            return e;
          }),
          assessmentType,
          assessmentResultId,
          timeTaken,
          submittionType,
          ...( breakSummary && {breakSummary}),
          session :localStorage.getItem('session') ?? null,
        };
        return await instance.post("save-assessment-data", data)
      } catch (error) {
        console.info("submitDynamicQuestion error", error);
        return error.response;
      }
    }
  },
  
  updateAssessmentStatus: async function (assessmentResultId) {
    if (!store.getters.token) {
      alert('TOKEN NOT FOUND');
    } else {
        try {
          const data = {
          assessmentResultId: assessmentResultId,
        };
        return instance.post("update-assessmentstatus", data);
      } catch (error) {
        console.info("submitDynamicQuestion error", error);
        return error.response;
      }
    }
  },

  getPsychometryReportData: async function (assessmentResultId) {
    try{
        const response = await instance.get("psychometryReport",{params: {assessmentResultId,}});
        
        return response.data;
    }
    catch(error) {
        console.error("Error fetching psychometry report:", error);
    }
  },
  
};

